import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityEmpresaDGILoadRequest,
  entityEmpresaDGILoadSuccess,
  entityEmpresaDGILoadFailure
} from './empresas-dgi.actions';

import { EmpresaDGIService } from './empresas-dgi.service';

@Injectable()
export class EmpresaDGIEffects {
  // load
  loadRequestEmpresaDGI = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEmpresaDGILoadRequest),
      mergeMap((action) =>
        this.empresaDGIService.getEmpresaDGI(action.rut).pipe(
          map((item) => entityEmpresaDGILoadSuccess({ item })),
          catchError((error) => of(entityEmpresaDGILoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private empresaDGIService: EmpresaDGIService
  ) {
    this.empresaDGIService.url = environment.apiUrl;
  }
}

